import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=c681ff28&scoped=true&"
import script from "./ProductOrder.vue?vue&type=script&lang=js&"
export * from "./ProductOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=c681ff28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c681ff28",
  null
  
)

export default component.exports